import { useEffect, useState } from "react";

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const pad = (n) => String(n).padStart(2, "0");

// Re-renders the caller every `intervalMs` with the current time.
const useClock = (intervalMs = 1000) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
};

export default useClock;

// Times use the 12-hour clock, as Sylvester's Mac and iPhone do.

// 9:41 (the iPhone's Lock Screen and status bar show it without AM/PM)
export const formatClock = (d) => `${d.getHours() % 12 || 12}:${pad(d.getMinutes())}`;

// 9:41 PM
export const formatTime = (d) => `${formatClock(d)} ${d.getHours() < 12 ? "AM" : "PM"}`;

// Sun 25 Oct (iPhone Lock Screen)
export const formatLockDate = (d) => `${DAYS[d.getDay()].slice(0, 3)} ${d.getDate()} ${MONTHS[d.getMonth()].slice(0, 3)}`;

// Sun 25 Oct 9:41 PM (macOS menu bar)
export const formatMenuBarDate = (d) =>
  `${DAYS[d.getDay()].slice(0, 3)} ${d.getDate()} ${MONTHS[d.getMonth()].slice(0, 3)}  ${formatTime(d)}`;

// 25 October 2026 at 9:41 PM (Notes header)
export const formatNoteDate = (d) =>
  `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()} at ${formatTime(d)}`;

// When something happened, as the iPhone's lists show it (Recents, Messages): the time today,
// "Yesterday", the weekday within a week, then the date.
export const formatListTime = (date, now) => {
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOfDay(now) - startOfDay(date)) / 86400000);
  if (days === 0) return formatTime(date);
  if (days === 1) return "Yesterday";
  if (days < 7) return DAYS[date.getDay()];
  return date.toLocaleDateString("en-GB");
};
